import { curaboxBaseConfig } from './base'

const config: RawPageConfig[] = [
  {
    ...curaboxBaseConfig,
    headers: {
      'X-Sepac-Environment': 'Curabox',
    },
    storyblok: {
      ...curaboxBaseConfig.storyblok,
      tokenNuxtRuntimeName: process.env.NUXT_PUBLIC_ENVIRONMENT === 'staging' ? 'curaboxDraftAccessToken' : 'curaboxPublishedAccessToken',
      accessLevel: process.env.NUXT_PUBLIC_ENVIRONMENT === 'staging' ? 'draft' : 'published',
    },
  },
]

export default config
